angular.module('gym.components').directive('addBrivoDetail', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/access_control/add_brivo_detail.html.slim'),
    scope: {
      contact: '=',
      loadBrivoDetail: '&'
    },
    controller: ["$scope", "$stateParams", "$http", function($scope, $stateParams, $http) {
      $scope.brivoDetail = {
        isNew: true
      };
      $scope.onDetailChange = function() {
        if ($scope.brivoDetail.isNew) {
          return $scope.brivoDetail.brivo_reference = '';
        }
      };
      $scope.loadUsers = function(refresh) {
        var refreshParams, url;
        refreshParams = refresh ? '&refresh=1' : '';
        url = `/gyms/${$stateParams.gymId}/access_control/users?count=10000&contact_id=${$scope.contact.id}${refreshParams}`;
        $scope.usersLoading = true;
        return $http.get(url).then(function(response) {
          $scope.usersLoading = false;
          return $scope.users = response.data.collection;
        }, function() {
          return $scope.usersLoading = false;
        });
      };
      $scope.loadUsers();
      $scope.isFormReady = function() {
        return !$scope.isLoading && ($scope.brivoDetail.isNew || $scope.brivoDetail.brivo_reference);
      };
      return $scope.save = function() {
        var url;
        $scope.isLoading = true;
        url = `/gyms/${$stateParams.gymId}/contacts/${$scope.contact.id}/brivo_details`;
        return $http.post(url, {
          contact_brivo_detail: $scope.brivoDetail
        }).then(function(data) {
          $scope.loadBrivoDetail();
          return $scope.isLoading = false;
        }, function() {
          return $scope.isLoading = false;
        });
      };
    }]
  };
});
